import ManageInterBankContract from "../pages/contractBooking/moneyMarket/interbankplacement/ManageInterBankContract";
import CreateInterBankContract from "../pages/contractBooking/moneyMarket/interbankplacement/CreateInterBankContract";
import ViewInterBankContract from "../pages/contractBooking/moneyMarket/interbankplacement/ViewInterBankContract";
import EditInterBankContract from "../pages/contractBooking/moneyMarket/interbankplacement/EditInterBankContract";
import ContractBookingManageTreasuryBill from "../pages/contractBooking/moneyMarket/treasury/ManageTreasuryBill";
import CreateTreasuryBill from "../pages/contractBooking/moneyMarket/treasury/CreateTreasuryBill";
import EditTreasuryBill from "../pages/contractBooking/moneyMarket/treasury/EditTreasuryBill";
import ManageTreasuryBill from "../pages/contractBooking/moneyMarket/treasury/ManageTreasuryBill";
import ViewTreasuryBill from "../pages/contractBooking/moneyMarket/treasury/ViewTreasuryBill";
import ManageBond from "../pages/contractBooking/moneyMarket/bond/ManageBond";
import CreateBond from "../pages/contractBooking/moneyMarket/bond/CreateBond";
import EditBond from "../pages/contractBooking/moneyMarket/bond/EditBond";
import ViewBond from "../pages/contractBooking/moneyMarket/bond/ViewBond";
import InterBankMainActionPage from "../pages/contractBooking/moneyMarket/interbankplacement/actions/InterBankMainActionPage";
import treasuryBillMainActionPage from "../pages/contractBooking/moneyMarket/treasury/actions/treasuryBillMainActionPage";
import BondContractMainActionPage from "../pages/contractBooking/moneyMarket/bond/actions/BondContractMainActionPage";

export default [
  // INTERBANK PLACEMENT
  {
    path: "/interbank-contract",
    component: ManageInterBankContract,
    isProtected: true,
  },
  {
    path: "/create-interbank-contract",
    component: CreateInterBankContract,
    isProtected: true,
  },
  {
    path: "/view-interbank-contract",
    component: ViewInterBankContract,
    isProtected: true,
  },
  {
    path: "/edit-interbank-contract",
    component: EditInterBankContract,
    isProtected: true,
  },
  // TREASURY BILL
  {
    path: "/contract-booking-treasury-bill",
    component: ContractBookingManageTreasuryBill,
    isProtected: true,
  },
  {
    path: "/create-contract-booking-treasury-bill",
    component: CreateTreasuryBill,
    isProtected: true,
  },
  {
    path: "/edit-contract-booking-treasury-bill",
    component: EditTreasuryBill,
    isProtected: true,
  },
  {
    path: "/view-contract-booking-treasury-bill",
    component: ViewTreasuryBill,
    isProtected: true,
  },

  // BOND
  {
    path: "/bond-contract",
    component: ManageBond,
    isProtected: true,
  },

  {
    path: "/new-bond-contract",
    component: CreateBond,
    isProtected: true,
  },

  {
    path: "/edit-bond-contract",
    component: EditBond,
    isProtected: true,
  },

  {
    path: "/detail-bond-contract",
    component: ViewBond,
    isProtected: true,
  },

  {
    path: "/interbank-contract-action",
    component: InterBankMainActionPage,
    isProtected: true,
  },
  {
    path: "/treasury-bill-contract-action",
    component: treasuryBillMainActionPage,
    isProtected: true,
  },
  {
    path: "/bond-contract-action",
    component: BondContractMainActionPage,
    isProtected: true,
  },
];
